import React from 'react';

export function GoogleTextlessSVG() {
    return (
        <svg
            width="20"
            height="26"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M22.9873 14.2247C22.9873 13.2414 22.909 12.5239 22.7397 11.7798H11.7285V16.2178H18.1918C18.0616 17.3207 17.3579 18.9816 15.7942 20.0977L15.7722 20.2463L19.2538 22.9965L19.495 23.021C21.7102 20.9349 22.9873 17.8654 22.9873 14.2247Z"
                fill="#4285F4"
            />
            <path
                d="M11.7289 25.9173C14.8954 25.9173 17.5537 24.8543 19.4954 23.0207L15.7945 20.0973C14.8042 20.8016 13.475 21.2932 11.7289 21.2932C8.62755 21.2932 5.99531 19.2071 5.05698 16.3237L4.91945 16.3356L1.2993 19.1925L1.25195 19.3267C3.18052 23.2332 7.14195 25.9173 11.7289 25.9173Z"
                fill="#34A853"
            />
            <path
                d="M5.05695 16.3238C4.80937 15.5797 4.66608 14.7824 4.66608 13.9586C4.66608 13.1347 4.80937 12.3375 5.04393 11.5934L5.03737 11.4349L1.37185 8.53223L1.25192 8.59039C0.457066 10.2115 0.000976562 12.0319 0.000976562 13.9586C0.000976562 15.8853 0.457066 17.7056 1.25192 19.3267L5.05695 16.3238Z"
                fill="#FBBC05"
            />
            <path
                d="M11.7289 6.62403C13.9311 6.62403 15.4166 7.59402 16.2637 8.40461L19.5735 5.10928C17.5407 3.1826 14.8954 2 11.7289 2C7.14195 2 3.18052 4.68406 1.25195 8.59056L5.04396 11.5936C5.9953 8.7102 8.62754 6.62403 11.7289 6.62403Z"
                fill="#EB4335"
            />
        </svg>
    );
}
